const AD_TRACKING_COOKIE_NAMES = [
	"gclid",
	"oppref",
	"msclkid",
	"utm_id",
	"li_fat_id",
	"li_click_id",
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_content",
	"utm_adgroup",
	"utm_term",
	"external_id",
	"wbraid",
	"gbraid",
	"rdt_cid",
	"fbclid",
	"event_id",
	"AAID",
	"IDFA",
] as const

function getCookie(name: string): string | undefined {
	const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
	return match?.[1] ? decodeURIComponent(match[1]) : undefined
}

export function getAdTrackingCookies(): Partial<
	Record<(typeof AD_TRACKING_COOKIE_NAMES)[number], string>
> {
	const values: Partial<Record<(typeof AD_TRACKING_COOKIE_NAMES)[number], string>> = {}

	for (const name of AD_TRACKING_COOKIE_NAMES) {
		const value = getCookie(name)
		if (value) values[name] = value
	}

	return values
}
